<template>
  <header class="wizard__header">
    <v-layout>
      <v-spacer />

      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" text>
            <v-icon color="gray-6">account_circle</v-icon>
            <span class="text-capitalize ml-1">{{ name }}</span>
            <v-icon color="gray-6" right small>keyboard_arrow_down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logoutSession">
            <v-list-item-title>{{ $t('Components.UserDropdownMenu.logout') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-layout>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import session from '@/services/modules/session'

export default {
  name: 'Header',
  computed: {
    ...mapState({
      name: ({ session }) => session?.user?.business?.name
    })
  },
  methods: {
    redirectToLogin () {
      this.$router.push({ name: 'Login' }).catch(e => {})
    },

    logoutSession () {
      session.logout()
      this.redirectToLogin()
    }
  }
}
</script>

<style lang="scss" scoped>
.wizard__header {
  left: 0;
  padding: 5px 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
